import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * Wrapper component that redirects to the logged-in user's profile
 */
const MyProfile = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (user?.id) {
      // Redirect to the user's profile page
      navigate(`/profile/${user.emp_id}`, { replace: true });
    } else {
      // If no user, redirect to dashboard
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
